import {Component, inject, Input} from '@angular/core';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {AgGridAngular} from "ag-grid-angular";
import {PlayersService} from "../../../services/players.service";
import {PlayerInfoTableDefs} from "../../player-game-info/player-info-table-defs";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IGamePlayerInputData} from "../../../interfaces/player/IGamePlayerInputData";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {IPlayerEmail} from "../../../interfaces/player/IPlayerEmail";
import {FirstDataRenderedEvent, GridSizeChangedEvent} from "ag-grid-community";

@Component({
  selector: 'app-manage-player-email-address-history',
  standalone: true,
  imports: [
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    AgGridAngular
  ],
  templateUrl: './manage-player-email-address-history.component.html',
  styleUrl: './manage-player-email-address-history.component.css'
})
export class ManagePlayerEmailAddressHistoryComponent {
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnum = UIStateEnum;
  public playerEmails: IPlayerEmail[] = [];

  private playerService: PlayersService = inject(PlayersService);
  private playerInfoTables: PlayerInfoTableDefs = inject(PlayerInfoTableDefs);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  public playerEmailColDefs = this.playerInfoTables.playerEmailHistoryColDefs;

  @Input()
  public set gamePlayerData(gamePlayerDataP: IGamePlayerInputData) {
    if (gamePlayerDataP.playerId) {
      this.getPlayerEmailHistory(gamePlayerDataP.playerId);
    }
  }

  public onFirstDataRendered(paramsP: FirstDataRenderedEvent) {
    paramsP.api.sizeColumnsToFit();
  }

  public onGridSizeChanged(paramsP: GridSizeChangedEvent) {
    paramsP.api.sizeColumnsToFit();
  }

  private getPlayerEmailHistory(playerIdP: string) {
    this.uiState = UIStateEnum.ShowLoading;
    this.playerService.getAllEmailsForPlayer(playerIdP).subscribe({
      next: emails => {
        this.uiState = UIStateEnum.ShowData;
        this.playerEmails = emails;
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to fetch email history for player", err);
      }
    })
  }
}
